define('MM/Components/ContentSearch/FacetMultipleChoicePanel',[
    "jquery",
    "knockout",
    "underscore",
    "score_bootstrap/Utils/UrlHelper",
    "score_bootstrap/Models/SitecoreId",
    "MM/Models/ContentSearch/FacetDropdownViewModel",
    "MM/Models/ContentSearch/FacetMultipleChoiceValue"
], function ($, ko, _, urlHelper, SitecoreId, FacetDropdownViewModel, FacetMultipleChoiceValue) {
    "use strict";

    var searchLogic = ["and", "or_total_count", "or_incremental_count"];

    function FacetMultipleChoicePanel(panelElement, allPreselected, urlParam) {
        var facetPanel = $(panelElement).data('facet');
        if (facetPanel != null) {
            // prevent assigning facet panel twice to the same element.
            return facetPanel;
        }
        Object.defineProperty(this, 'scope', { value: panelElement, enumerable: !0, configurable: !0, writable: !1 });

        var $dataEl = $(".js-facet", panelElement),
            title = $dataEl.data("title"),
            titleText = $dataEl.data("title-text"),
            searchLogicType = $dataEl.data("search-logic-type").toLowerCase(),
            preselectedValueByBackend = $dataEl.data("preselected-value"),
            preselectedByTitle = allPreselected[title] || preselectedValueByBackend || "",
            initialSelectedOptionText = $dataEl.data("placeholder"),
            facets = [];

        if (preselectedValueByBackend && !window.location.hash) {
            urlHelper.setHashValue(window.location, urlParam, title + ":" + preselectedValueByBackend);
        }

        var viewModel = new FacetDropdownViewModel(initialSelectedOptionText);
        viewModel.isAnySelected.subscribe(this._isAnySelectedHandler.bind(this));
        ko.applyBindings(viewModel, $dataEl.get(0));

        $(".js-row", panelElement).each(function () {
            var $el = $(this),
                id = $el.data("id"),
                val = $el.data("value"),
                text = $el.find('> label > .score-facet-value').text();
            facets.push(new FacetMultipleChoiceValue(id, val, text, $el[0], preselectedByTitle.indexOf(val) > -1, $dataEl));
        });

        $(".ipa-back", panelElement).on("click", function (e) {
            e.preventDefault();
            $(".score-button-menu", panelElement).removeClass("open");
        });

        Object.defineProperties(this, {
            title: { value: title },
            titleText: { value: titleText },
            searchLogicType: { value: searchLogic.indexOf(searchLogicType) },
            facets: { get: Array.prototype.slice.bind(facets) },
            asString: {
                get: function () {
                    var selectedFacets = facets.filter(function (facet) { return facet.selected(); });
                    var result = selectedFacets.map(function(facet) { return facet.value; }).join('|');
                    
                    if (!result) {
                        if (viewModel.selectedOptionText() !== initialSelectedOptionText) {
                            viewModel.selectedOptionText(initialSelectedOptionText);
                        }
                        viewModel.isAnySelected(false);
                        return null;
                    }

                    if (selectedFacets.length > 1) {
                        viewModel.selectedOptionText(selectedFacets[0].text + ' (+' + (selectedFacets.length -1) + ')');
                    } else if (selectedFacets.length === 1) {
                        viewModel.selectedOptionText(selectedFacets[0].text);
                    } else {
                        viewModel.selectedOptionText(result);
                    }
                    viewModel.isAnySelected(true);
                    return this.title + ":" + result;

                }
            }
        });

        this.selectValues = function(selectedValues) {
            var selectedByTitle = selectedValues[title] || "";
            facets.forEach(function (facet) {
                var oldValue = facet.selected();
                var newValue = selectedByTitle.indexOf(facet.value) > -1;
                if (oldValue !== newValue) {
                    facet.selected(selectedByTitle.indexOf(facet.value) > -1);
                }
            });
        };

        this.selectedValues = ko.pureComputed(function () {
            return _.filter(facets, function (val) {
                return val.selected();
            });
        });

        this.unselectAll = function unselectAll() {
            this.selectedValues().forEach(function (value) {
                value.selected(false);
            });

            viewModel.selectedOptionText(initialSelectedOptionText);
        };

        // Subscription to trigger from FacetMultipleChoiceValue which are always exist as a list options View Models in here. That's why without EventManager. 
        $dataEl.on("MultipleChoiceValue:disabled:checking", function () {
            this.updateBySelectedOption($dataEl, facets, initialSelectedOptionText, preselectedByTitle, this.titleText);
        }.bind(this));

        $(panelElement).data('facet', this);
    }

    // It always reloads when I use viewModel.selectedOptionText() to update UI regarding selected and enabled list options based on retrieved from server side-data.
    // Made decision to implement this using jQuery.
    FacetMultipleChoicePanel.prototype.updateBySelectedOption = function updateBySelectedOption($dataEl, facets, initialSelectedOptionText, preselectedByTitle, titleText) {
        var result = "";
        var cssClass = "is-any-selected";
        var isAnySelected = true;
        var selectedResult = facets.filter(function (el) { return el.selected() && !el.disabled(); });
        var preSelectedResult = preselectedByTitle ? facets.filter(function (el) { return el.value == preselectedByTitle[0]; }) : null;
        var selectedCount = selectedResult.length;

        if (selectedCount > 1) {
            result = selectedResult[0].text + ' (+' + (selectedResult.length -1) + ')';
        } else if (selectedCount === 1) {
            result = selectedResult[0].text;
        } else {
            if (preselectedByTitle && preSelectedResult) {
                result = preSelectedResult.text;
            }
            else {
                result = initialSelectedOptionText;
            }

            isAnySelected = false;
        }

        isAnySelected ? $dataEl.addClass(cssClass) : $dataEl.removeClass(cssClass);
        $dataEl.text(result);
    }

    FacetMultipleChoicePanel.prototype._isAnySelectedHandler = function _isAnySelectedHandler(isSelected) {
        var btnEl = this.scope.querySelector('.score-button-menu > .score-button');
        // skip logic
        if(!btnEl) return;
        // define add/remove based on is there any selected item
        (isSelected 
            ? btnEl.classList.add('selection-complete') 
            : btnEl.classList.remove('selection-complete')
        );
    }    

    return FacetMultipleChoicePanel;
});
